import { CircularProgress, Grid, Skeleton } from '@mui/material';
import { styled } from "@mui/material/styles";
import { AssistantAvatar } from './Avatar';

const Loader = styled('div')(({ theme }) => {
    const color = theme.palette.primary[600];

    return {
        position: 'relative',
        left: '-9999px',
        width: '10px',
        height: '10px',
        borderRadius: '5px',
        animation: 'dot-typing 1.2s infinite linear',
        '@keyframes dot-typing': {
            '0%': {
                boxShadow: `9984px 0 0 0 ${color}, 9999px 0 0 0 ${color}, 10014px 0 0 0 ${color}`,
            },
            '16.667%': {
                boxShadow: `9984px -10px 0 0 ${color}, 9999px 0 0 0 ${color}, 10014px 0 0 0 ${color}`,
            },
            '33.333%': {
                boxShadow: `9984px 0 0 0 ${color}, 9999px 0 0 0 ${color}, 10014px 0 0 0 ${color}`,
            },
            '50%': {
                boxShadow: `9984px 0 0 0 ${color}, 9999px -10px 0 0 ${color}, 10014px 0 0 0 ${color}`,
            },
            '66.667%': {
                boxShadow: `9984px 0 0 0 ${color}, 9999px 0 0 0 ${color}, 10014px 0 0 0 ${color}`,
            },
            '83.333%': {
                boxShadow: `9984px 0 0 0 ${color}, 9999px 0 0 0 ${color}, 10014px -10px 0 0 ${color}`,
            },
            '100%': {
                boxShadow: `9984px 0 0 0 ${color}, 9999px 0 0 0 ${color}, 10014px 0 0 0 ${color}`,
            },
        },
    };
});

export const AssistantLoader = () => {
    return (
        <Grid sx={{
            width: '100%',
            paddingY: '15px',
            height: 'fit-content',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '25px',
        }} container>
            <AssistantAvatar />
            <Loader />
        </Grid>
    );
}

const MessageSkeleton = ({ reverse = false }) => {
    return (
        <Grid
            sx={{
                display: 'flex',
                flexDirection: reverse ? 'row' : 'row-reverse',
                paddingY: '25px',
                gap: '25px',
            }}
        >
            <Skeleton variant="circular" width={50} height={50} />
            <Skeleton sx={{
                borderRadius: '10px',
            }} variant="rectangular" width={'60%'} height={120} />
        </Grid>
    );
}

export const ConversationSkeleton = ({ items = 2 }) => {
    return (
        <Grid
            sx={{
                width: 'inherit',
            }}
        >
            {Array.from({ length: items }).map((_, index) => (
                <MessageSkeleton key={index} reverse={index % 2} />
            ))}
        </Grid>
    );
}

export const CircularLoader = () => {
    return (
        <Grid
            sx={{
                textAlign: 'center',
            }}
        >
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", margin: "10%" }}><div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", margin: "10%" }}><CircularProgress /></div></div>
        </Grid>
    );
}